import React from 'react';
import { connect } from 'react-redux';
import { archivedIcon } from '@/constants/images';
import { showRoleReassign } from '@/roles/actions';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import { showArchiveUser, toggleUserApproved, toggleUserSearchable } from '../actions';
import UserApproveTool from '../components/UserApproveTool';
import UserSearchableTool from '../components/UserSearchableTool';
import UserRoleTool from '../components/UserRoleTool';

const UserTools = ({
  allowRead,
  allowSearchable,
  canApprove,
  canArchive,
  canAssignRoles,
  category,
  isCurrentUser,
  listItem = false,
  onRoleReassign,
  onToggleApproved,
  onToggleSearchable,
  showArchive,
  upward,
  url,
  user,
}) => (
  <StandardToolsMenu
    allowDelete={canArchive}
    allowRead={allowRead}
    deleteIcon={archivedIcon(!user.archived)}
    deleteMessage={user.archived ? 'actions.restore' : 'actions.archive'}
    deleteWarningMessage={isCurrentUser ? 'user.permission.warning' : undefined}
    href={url}
    listItem={listItem}
    onDelete={() => showArchive(category, user.code)}
    upward={upward}
  >
    {canApprove && (
    <UserApproveTool
      approved={user.approved}
      divider
      isCurrentUser={isCurrentUser}
      onClick={() => onToggleApproved(category, user.code)}
    />
    )}
    {allowSearchable && (
    <UserSearchableTool
      divider={!canApprove}
      onClick={() => onToggleSearchable(category, user.code)}
      searchable={user.searchable}
    />
    )}
    {canAssignRoles && (<UserRoleTool onClick={() => onRoleReassign([user])} divider />)}
  </StandardToolsMenu>
);

const mapStateToProps = ({
  auth: { currentUser, role: { permissions: { users, roles } } },
}, { user }) => (
  {
    allowRead: users.read,
    allowSearchable: users.update && !user.archived,
    canApprove: users.approve && (!user.archived || user.approved),
    canArchive: users.destroy,
    canAssignRoles: roles.assign && !user.archived,
    isCurrentUser: user.code === currentUser.id,
  }
);

const mapDispatchToProps = {
  showArchive: showArchiveUser,
  onRoleReassign: showRoleReassign,
  onToggleApproved: toggleUserApproved,
  onToggleSearchable: toggleUserSearchable,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserTools);
